import type { Span } from '@sentry/core'

let _routeSpan: Span | undefined

export function setRouteSpan(span: Span | undefined): void {
  _routeSpan?.end()
  _routeSpan = span
}

export function getRouteSpan(): Span | undefined {
  return _routeSpan
}
